import { rewardApi } from 'yxt-biz-pc/packages/api';

// 获取用户未弹出的自定义勋章
export const getUnpopedCustomMedals = () => {
  return rewardApi.get('user/medal/pop/list');
};

/**
 * 更新已弹出的自定义勋章状态
 * @param {*} ids 弹出的勋章id集合
 * @returns
 */
export const updateCustomMedalStatus = (ids) => {
  return rewardApi.post('user/medal/pop/notice', { medalDetailIds: ids });
};
